export const PwdRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\S]{6,18}$/